import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_BY_AGE_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_BY_PHASE_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ARCHIVED_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ARCHIVED_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ITEM_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ITEM_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ARCHIVED_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ARCHIVED_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ITEM_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ITEM_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_PHASE_DETAILS_PATH,
  CHILDREN_HEALTH_MILESTONES_LIST_BY_PHASE_PATH,
  CHILDREN_HEALTH_MILESTONES_PATH,
  CHILDREN_HEALTH_MILESTONES_TODO_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const MilestonesHabitTrackerItemsByPhaseDetailPage = lazy(
  () => import('./pages/MilestonesHabitTrackerItemsByPhaseDetailPage/MilestonesHabitTrackerItemsByPhaseDetailPage')
);
const MilestonesHabitTrackerItemsByAgeDetailPage = lazy(
  () => import('./pages/MilestonesHabitTrackerItemsByAgeDetailPage/MilestonesHabitTrackerItemsByAgeDetailPage')
);
const MilestonesTodoPage = lazy(() => import('./pages/MilestonesTodoPage/MilestonesTodoPage'));
const MilestonesPage = lazy(() => import('./pages/MilestonesPage/MilestonesPage'));
const MilestonesListByPhasePage = lazy(() => import('./pages/MilestonesListByPhasePage/MilestonesListByPhasePage'));
const MilestonesListByPhaseDetailsPage = lazy(
  () => import('./pages/MilestonesListByPhaseDetailsPage/MilestonesListByPhaseDetailsPage')
);
const MilestonesListByAgePage = lazy(() => import('./pages/MilestonesListByAgePage/MilestonesListByAgePage'));
const MilestonesListByAgeItemsPage = lazy(
  () => import('./pages/MilestonesListByAgeItemsPage/MilestonesListByAgeItemsPage')
);
const MilestonesListByAgeItemsDetailsPage = lazy(
  () => import('./pages/MilestonesListByAgeItemsDetailsPage/MilestonesListByAgeItemsDetailsPage')
);
const MilestonesListByCategoriesPage = lazy(
  () => import('./pages/MilestonesListByCategoriesPage/MilestonesListByCategoriesPage')
);
const MilestonesListByCategoriesItemsPage = lazy(
  () => import('./pages/MilestonesListByCategoriesItemsPage/MilestonesListByCategoriesItemsPage')
);
const MilestonesListByCategoriesItemsDetailsPage = lazy(
  () => import('./pages/MilestonesListByCategoriesItemsDetailsPage/MilestonesListByCategoriesItemsDetailsPage')
);
const MilestonesHabitTrackerItemsPage = lazy(
  () => import('./pages/MilestonesHabitTrackerItemsPage/MilestonesHabitTrackerItemsPage')
);
const MilestonesHabitTrackerItemsDetailsPage = lazy(
  () => import('./pages/MilestonesHabitTrackerItemsDetailPage/MilestonesHabitTrackerItemsDetailPage')
);
const MilestonesArchivedByAgePage = lazy(
  () => import('./pages/MilestonesArchivedByAgePage/MilestonesArchivedByAgePage')
);
const MilestonesArchivedByAgeDetailsPage = lazy(
  () => import('./pages/MilestonesArchivedByAgeDetailsPage/MilestonesArchivedByAgeDetailsPage')
);
const MilestonesArchivedByCategoriesPage = lazy(
  () => import('./pages/MilestonesArchivedByCategoriesPage/MilestonesArchivedByCategoriesPage')
);
const MilestonesArchivedByCategoriesDetailsPage = lazy(
  () => import('./pages/MilestonesArchivedByCategoriesDetailsPage/MilestonesArchivedByCategoriesDetailsPage')
);

export const CHILDREN_HEALTH_MILESTONES_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesPage />,
    displayTitle: () => 'Milestones',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByPhasePage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_PHASE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesTodoPage />,
    displayTitle: () => '',
    isLandingPage: true,
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_TODO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByPhaseDetailsPage />,
    displayTitle: () => 'Milestones Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_PHASE_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesHabitTrackerItemsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesHabitTrackerItemsDetailsPage />,
    displayTitle: () => 'Habit Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },

  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesHabitTrackerItemsByPhaseDetailPage />,
    displayTitle: () => 'Habit Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_BY_PHASE_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },

  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesHabitTrackerItemsByAgeDetailPage />,
    displayTitle: () => 'Habit Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_HABIT_TRACKER_ITEM_BY_AGE_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByAgePage />,
    displayTitle: () => 'Milestones and Healthy Habit Tracker by Age',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByAgeItemsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ITEM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByAgeItemsDetailsPage />,
    displayTitle: () => 'Milestones Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ITEM_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesArchivedByAgePage />,
    displayTitle: () => 'Archived Milestones',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ARCHIVED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesArchivedByAgeDetailsPage />,
    displayTitle: () => 'Milestones Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_AGE_ARCHIVED_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByCategoriesPage />,
    displayTitle: () => 'Milestones and Healthy Habit Tracker by Categories',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByCategoriesItemsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ITEM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesListByCategoriesItemsDetailsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ITEM_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesArchivedByCategoriesPage />,
    displayTitle: () => 'Archived Milestones',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ARCHIVED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MilestonesArchivedByCategoriesDetailsPage />,
    displayTitle: () => 'Milestones Details',
    pageType: PageType.PRIVATE,
    path: CHILDREN_HEALTH_MILESTONES_LIST_BY_CATEGORIES_ARCHIVED_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.milestones,
  },
];
